/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Charspage_Meta_TitleInputs */

const en_fw_charspage_meta_title = /** @type {(inputs: Fw_Charspage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding Characters & Voice Cast (Anime 2026)`)
};

const zh_fw_charspage_meta_title = /** @type {(inputs: Fw_Charspage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁角色图鉴与声优表（2026 动画）`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding Characters & Voice Cast (Anime 2026)" |
*
* @param {Fw_Charspage_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_charspage_meta_title = /** @type {((inputs?: Fw_Charspage_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Charspage_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_charspage_meta_title(inputs)
	return zh_fw_charspage_meta_title(inputs)
});
export { fw_charspage_meta_title as "fw.charspage.meta_title" }